<template>
  <div>
    <InputFilter
      class="pt-10"
      :hideDetails="false"
      :hint="hint"
      :loading="loading"
    />

    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="10" class="mx-auto py-0">
            <v-row justify="space-between">
              <v-col cols="12" sm="3" class="success-select pb-0">
                <v-autocomplete
                  class="pt-0"
                  color="#1B5E20"
                  :items="subInventories"
                  item-text="name"
                  item-value="id"
                  :label="$t('label.subInventory')"
                  :loading="loading"
                  :disabled="loading"
                  clearable
                  @change="setInventoryLocators"
                  v-model="filterInputs.inventory"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="error-select pb-0">
                <v-autocomplete
                  class="pt-0"
                  color="#B71C1C"
                  :items="locators"
                  item-text="name"
                  item-value="id"
                  :label="$t('label.locator')"
                  :loading="loading"
                  :disabled="
                    loading || loadingLocators || !filterInputs.inventory
                  "
                  v-model="filterInputs.locator_id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="success-select pb-0">
                <v-autocomplete
                  class="pt-0"
                  :items="filterArray"
                  item-text="name"
                  item-value="name"
                  label="Filter By"
                  v-model="filterInputs.filter"
                  @change="filterCamps"
                  :append-icon="filterInputs.filter ? 'mdi-close' : ''"
                  @click:append="clearSearchData('filter')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="d-flex align-center pb-0">
                <v-checkbox
                  class="mt-0"
                  :label="$t('label.includeZeroQty')"
                  false-value="no"
                  true-value="yes"
                  background-color="#e0f1f7"
                  on-icon="mdi-checkbox-marked-circle"
                  off-icon="mdi-checkbox-marked-circle-outline"
                  v-model="filterInputs.without_zero"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "SCMOnHandsFilterComponent",
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter"),
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    subInventories: {
      type: Array,
      required: true,
    },
  },
  async mounted() {
    if (this.$route.query.locator_type) {
      this.filterInputs.locator_type = this.$route.query.locator_type;
      this.filterInputs.locator_type !== "none" && (await this.fetchLocators());
    }

    Object.keys(this.filterInputs).forEach((key) => {
      if (key === "without_zero") {
        this.filterInputs[key] =
          !this.$route.query[key] && this.$route.query[key] === "no"
            ? "no"
            : "yes";
      } else {
        this.filterInputs[key] = this.$route.query[key] || "";
      }
    });
    this.mappingQueryFiltersInputs = false;
  },
  data() {
    return {
      locators: [],
      filterArray: [
        { name: "all" },
        { name: "camps-employees" },
        { name: "inventory" },
      ],

      filterInputs: {
        inventory: "",
        filter: "",
        without_zero: "no",
        locator_type: "",
        locator_id: "",
      },
      loadingLocators: false,
      mappingQueryFiltersInputs: true,
      hint: this.$t("search_hint"),
    };
  },
  computed: {
    selectedSCMInventoryInfo() {
      const selectedSCMInventory = this.filterInputs.inventory
        ? this.subInventories.find(
            (inventory) =>
              inventory.id.toString() === this.filterInputs.inventory.toString()
          )
        : {};
      return selectedSCMInventory || {};
    },
  },
  methods: {
    async fetchLocators() {
      try {
        const reqName =
          this.filterInputs.locator_type === "camp"
            ? "scm/camps"
            : "scm/employees";

        this.loadingLocators = true;
        const res = await IndexData({ reqName, query: { pagination: "all" } });
        this.locators = res.data.data.map((locator) => ({
          ...locator,
          id: locator.id.toString(),
        }));
      } catch (err) {
        console.log();
      } finally {
        this.loadingLocators = false;
      }
    },
    setInventoryLocators() {
      this.filterInputs.locator_id = "";
      if (!this.selectedSCMInventoryInfo.id) {
        this.filterInputs.locator_type = "";
        return;
      }
      if (
        !this.selectedSCMInventoryInfo.for_camps &&
        !this.selectedSCMInventoryInfo.for_employees
      ) {
        this.filterInputs.locator_type = "none";
        return;
      }

      this.filterInputs.locator_type = this.selectedSCMInventoryInfo.for_camps
        ? "camp"
        : "employee";
      this.fetchLocators();
    },
    filterCamps(filter) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, filter, page: 1 } });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filterInputs[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
  },
  watch: {
    filterInputs: {
      handler(filtersVal, oldFiltersVal) {
        if (
          this.mappingQueryFiltersInputs ||
          (oldFiltersVal.locator_id && !filtersVal.locator_id) ||
          (oldFiltersVal.locator_type && !filtersVal.locator_type)
        ) {
          return;
        }

        const queryData = Object.keys(filtersVal).reduce((acc, key) => {
          acc[key] = filtersVal[key] || "";
          return acc;
        }, {});
        this.$router.push({
          query: { ...this.$route.query, ...queryData, page: 1 },
        });
      },
      deep: true,
    },
  },
};
</script>
